import React from "react";
import { Grid, LinearProgress } from "@mui/material";
import { Box } from "@mui/system";
import LogoWithTitle from "../../../assests/logo.png";
import { useSelector } from "react-redux";
import useMobileDetection from "../../../Hooks/useMobileDetection";

export default function SpinnerCustom({ state = false, positionTop = "200px" }) {

  const isMobile = useMobileDetection();
  const appLoadingState = useSelector((state) => state.appLoader.loading);
  let spinnerWidth = isMobile ? "200px" : "300px" 

  return (
    <React.Fragment>
      {appLoadingState &&
        <div className="modal custom-spinner">
          <Grid container sx={{ display: "flex", justifyContent: "center", paddingTop: positionTop }} >
            <Grid className="flex-center-center" item xs={12} md={12} lg={12} >              
              <Box sx={{marginBottom:"10px"}}>
                <img src={LogoWithTitle} alt="Logo" width={spinnerWidth} />            
              </Box>
            </Grid>
            <Grid className="flex-center-center" item xs={12} md={12} lg={12} >
              <LinearProgress sx={{ width: spinnerWidth }} />
            </Grid>
          </Grid>
        </div>
      }
    </React.Fragment>
  )
}